// import cuid from "cuid";
// import { PROJECT_SOURCE, PROJECT_TYPES, SALE_MODES } from "utils/constants";
import { get } from "lodash";
import { useQuery } from "shared/hooks/useApi";
import { COVERAGE_CATEGORIES } from "utils/api/graphql/queries/coverage-categories";
import Template from "../Template";
import View from "./View";

const CollectionNeeds = ({
  project,
  onBack,
  currentStatus,
  onNext,
  processId,
}) => {
  const { data } = useQuery(COVERAGE_CATEGORIES, {
    variables: { where: { processId }, gt: { weight: 0 } },
  });
  const next = (fields) => {
    onNext({
      payload: {
        fields: {
          ...fields,
          needs: get(data, "coverageCategories.data", []).reduce(
            (acc, { value }) => {
              acc[value] = get(fields, "selectedLevel", 1);
              return acc;
            },
            {},
          ),
        },
      },
    });
  };

  return (
    <Template
      onBack={onBack}
      progress={currentStatus.progress}
      project={project}
      View={
        <View
          onNext={next}
          fields={get(project, "fields", {})}
          onBack={onBack}
        />
      }
    />
  );
};

export default CollectionNeeds;
